import { render, staticRenderFns } from "./SingleNewsRender.vue?vue&type=template&id=7847a768&scoped=true&"
import script from "./SingleNewsRender.vue?vue&type=script&lang=ts&"
export * from "./SingleNewsRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847a768",
  null
  
)

export default component.exports